import Slider from 'react-slick';

// slick carousel
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { useState } from 'react';



// Custom Right Arrow Component
const RightArrow = ({ onClick }) => (
  <div
    onClick={onClick}
    className={'arrowInCategories'}
  >
    <i className="fa-solid fa-right-long"></i>
  </div>
);

const CategorySlider = ({children,bgDark,data}) => {
    const [currentIndex, setCurrentIndex] = useState(0); // Track the current slide index


  const settings = {
    dots: false,
    infinite: false,
    nextArrow: <RightArrow />, // Add custom right arrow
    slidesToShow: 7,
    slidesToScroll: 1,
    speed: 200,
    initialSlide: 0,
    swipeToSlide: true,
    arrows:currentIndex>0 ? false : true,
    afterChange: (index) => {
      setCurrentIndex(index); // Update current slide index
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          dots: false,
          slidesPerRow:2,
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          dots: false,
          slidesPerRow:2,
          slidesToShow: 2,
          slidesToScroll:1
        }
      }
    ]
  };



  return (
    <>
    {
      data.length !== 0 ? 
      <div className={`slickContainer`}>
      <Slider
      {...settings}
      >
     {children}
        </Slider>
      </div>
      : null
    }
    </>

  )


}

export default CategorySlider;